import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import FormError from "../../../components/forms/FormError";
import {List} from "immutable";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

class ProductSurchargeForm extends Component {

  render() {
    let {errors, handleSubmit, submit, currencies, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    let currencyFields = currencies.map(currency => {
      return (
        <Field 
          key={currency}
          label={currency}
          name={`surcharge[${currency}]`}
          serverError={this.props.errors.surcharge}
          component={TextInputField}
          normalize={numerical}
          />
      )
    });

    let stateProvinceInput = null;
    if (this.props.showStateProvince) {
      stateProvinceInput = <Field
        label="State / Province"
        name="addressStateProvince"
        component={TextInputField}
        serverError={this.props.errors.stateCode}
        />
    }
    if (this.props.stateProvinces.size > 0) {
      stateProvinceInput = <Field
        label="State / Province"
        name="stateCode"
        component={DropDownInputField}
        data={this.props.stateProvinces}
        valueKey="code"  
        titleKey="name"
        serverError={this.props.errors.stateCode}
        />
      }


    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field
              label="Country"
              name="countryCode"
              component={DropDownInputField}
              data={this.props.countries}
              valueKey="countryCode"  
              titleKey="countryName" 
              serverError={this.props.errors.countryCode}
              />   
            {stateProvinceInput}       
            {currencyFields}
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

ProductSurchargeForm.defaultProps = {
  stateProvinces: List([]),
  showStateProvince: false
}

const ReduxForm = reduxForm({
  form: "ProductSurchargeForm"
})(ProductSurchargeForm);

export default ReduxForm;